import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import axios from "axios";
import toast from "react-hot-toast";
import { PAY_URL } from "../../../BaseURL";

export const userLogin = createAsyncThunk(
    '/login/userLogin',
    async (login, { rejectWithValue }) => {
        try {
            const myurl = `${PAY_URL}/user/login`;
            const bodyFormData = new URLSearchParams();

            bodyFormData.append('email', login.email);
            bodyFormData.append('password', login.password);

            const response = await axios({
                method: 'post',
                url: myurl,
                data: bodyFormData,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });

            const loginData = response.data;

            if (loginData.success === true) {
                localStorage.setItem('PAY_USER_TOKEN', loginData?.data?.token);
                localStorage.setItem('PAY_USER_NAME', loginData?.data?.name);
                localStorage.setItem('PAY_USER_ID', loginData?.data?.id);
                localStorage.setItem('PAY_USER_EMAIL', loginData?.data?.email);
                localStorage.setItem('PAY_USER_YEAR', `${loginData?.data?.year?.start_year}-${loginData?.data?.year?.end_year}`)
                toast.success(loginData?.message);
                return loginData;
            } else {
                throw new Error(loginData.message);
            }
        } catch (error) {
            console.log(error, 'Error');
            toast.error(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);


const userLoginSlice = createSlice({
    name: "login",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(userLogin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(userLogin.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(userLogin.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default userLoginSlice.reducer;